<template>
  <div :class="{ 'custom-error': validator && validator.$error }">
    <vue-editor
      :id="getUID()"
      :value="value"
      :editor-toolbar="editorToolbar"
      :placeholder="placeholder"
      :disabled="disabled"
      :use-custom-image-handler="true"
      @image-added="handleImageAdded"
      @input="
        $emit('input', $event)
        validator && validator.$touch()
      "
      @blur="validator && validator.$touch()"
    />
    <div :class="['custom-error-message', { 'error--text': validator && validator.$error }]">
      <span> {{ getErrors(validator)[0] }} &nbsp;</span>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

import {
  defaultMessages,
  getUploadOptions,
  getValidationErrors,
  uploadImage,
} from './../../../utils'
import { UploadPaths } from '@/types'

const toolbar = [
  ['bold', 'italic', 'underline', 'strike', { size: ['small', false, 'large', 'huge'] }],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
]

export default {
  name: 'text-editor-field',
  components: {
    VueEditor,
  },
  props: {
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    imageAndCodeBlockEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editorToolbar: this.imageAndCodeBlockEnabled ? toolbar.concat([['image', 'video']]) : toolbar,
      imageUploadLoading: false,
    }
  },
  methods: {
    getErrors: function (field) {
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
    async handleImageAdded(fileImage, Editor, cursorLocation, resetUploader) {
      this.imageUploadLoading = true
      const { file, path } = await getUploadOptions(fileImage, UploadPaths.UNGROUPED, {
        resize: false,
      })
      const url = await uploadImage(file, path)
      this.imageUploadLoading = false

      Editor.insertEmbed(cursorLocation, 'image', url)
      resetUploader()
    },
  },
}
</script>

<style>
.ql-container {
  border: 0px !important;
}

.ql-editor {
  font-family: 'Source Sans Pro', sans-serif;
  border-bottom: 0.125rem #979797 solid !important;
}

.ql-editor:focus {
  border-bottom: 0.125rem #0277bd solid !important;
}

.ql-editor:hover {
  background-color: rgba(2, 119, 189, 0.2) !important;
}

.ql-editor::before {
  font-style: normal !important;
  color: rgba(0, 0, 0, 0.54);
}
.custom-error .ql-editor {
  border-bottom: 0.125rem #db384c solid !important;
}

.ql-toolbar {
  border: 0px !important;
  background: rgba(0, 0, 0, 0.06);
}

.ql-editor p img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}

.ql-editor iframe {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
}
</style>
